<template>
  <!--  -->
  <div class="chart-doughnut" />
<!--  :style="{background: `url('/imgs/doughnut-bg.png') center / auto ${39 * 0.85}% no-repeat`}" -->
</template>

<script>
import chartInitMixin from "@/views/mixin/chartInitMixin";
import chartConfig from '@/utils/chartConfig'

const colors = ['#ff4848', '#487ca9', '#226caa', '#2243a8', '#405ca8', '#6074a7', '#7f88a7', '#6384a8']
const colorsBG = ['#325982', '#304c72', '#335e87', '#304d74', '#405ca8', '#6074a7', '#7f88a7', '#6384a8']
const bgData = [ 0.07, 0.36, 0.15, 0.4, 0.12, 0.04 ]

export default {
  name: 'chart-doughnut',
  mixins: [
    chartInitMixin,
  ],
  components: {},
  props: {
    data: Array,
    showLabel: Boolean,
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.update()
      }
    },
  },
  methods: {
    update() {
      const {data, width} = this
      if (!data || !data.length) return
      console.log('#$$ width', width)
      const option = {
        tooltip: Object.assign({}, chartConfig.tooltip, {trigger: 'item'}),
        series: [
          {
            type: 'pie',
            radius: ['35%', '70%'],
            center: ['50%', '50%'],
            labelLine: {
              show: true
            },
            label: {
              show: true,
              distanceToLabelLine: 0,
              backgroundColor: 'rgba(35,67,168, 0.1)',
              padding: 3,
              color: '#fff',
              fontFamily: '"OPPOSans R",sans-serif',
            },
            itemStyle: {
              color: ({dataIndex}) => data[dataIndex].color || colors[dataIndex] || colors[dataIndex.length - 1]
            },
            data: data.map(item => {
              return {
                name: item.name,
                value: item.value,
                label: {
                  formatter(e) {
                    return `${e.name}\n${e.percent}%`
                  }
                }
              }
            })
          },
          {
            type: 'pie',
            silent: true,
            radius: ['75%', '80%'],
            center: ['50%', '50%'],
            labelLine: false,
            itemStyle: {
              color: ({dataIndex}) => data[dataIndex].color || colors[dataIndex] || colors[dataIndex.length - 1],
              opacity: 0.3
            },
            data: data.map(item => item.value)
          },
          {
            type: 'pie',
            silent: true,
            radius: ['50%', '35%'],
            center: ['50%', '50%'],
            labelLine: false,
            itemStyle: {
              color: ({dataIndex}) => data[dataIndex].color || colors[dataIndex] || colors[dataIndex.length - 1],
              opacity: 0.3
            },
            data: data.map(item => item.value)
          },
          { // 背景外圈
            type: 'pie',
            silent: true,
            radius: ['32%', '15%'],
            center: ['50%', '50%'],
            labelLine: false,
            itemStyle: {
              color: ({dataIndex}) => colorsBG[dataIndex],
              opacity: 0.4,
            },
            data: bgData,
          },
          { // 背景中心
            type: 'pie',
            silent: true,
            radius: ['15%'],
            center: ['50%', '50%'],
            labelLine: false,
            itemStyle: {
              color: ({dataIndex}) => colorsBG[dataIndex],
              opacity: 0.7,
            },
            data: bgData,
          },
        ],
      }
      this.chart.setOption(option)
    }
  }
}
</script>
